<template>
  <div id="body" class="theme-cyan">
    <div class="overlay"></div>
    <!-- Top Bar -->
    <nav class="top_navbar">
      <div class="container">
        <div class="row clearfix">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <div class="navbar-logo" >
                <a
                  href="javascript:void(0);"
                  class="bars"
                  @click="showLeftMenu"
                ></a>
                <router-link class="navbar-brand" to="/workflows"
                  ><img
                    src="@/assets/images/finallogo.png"
                    width="30"
                    alt="Amaze"
                  /><span class="ml-2">EASY WORK</span></router-link
                >
              </div>
              <div
                class="
                  d-flex
                  justify-content-end
                  align-items-center
                  flex-grow-1
                "
              >
                <ul class="navbar">
                  <li class="dropdown profile">
                    <a
                      href="javascript:void(0);"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      @click="dropdownLogin"
                      ref="userBtn"
                    >

                      {{this.$store.state.userStore.userName}}
<!--                      {{ loginoutText }}-->
                    </a>
                    <ul class="dropdown-menu show" v-if="clickedUserDropDown">
                      <li v-if="getEmail">
                        <div class="user-info">
                          <h5 class="user-name mb-0" style="font-size: 100%;">
                            {{ this.$store.state.userStore.userEmail }}
                          </h5>

                          <hr />
                        </div>
                      </li>
                      <li v-if="!getEmail">
                        <router-link to="/"
                          ><i class="zmdi zmdi-power"></i><span> 로그인</span>
                        </router-link>
                      </li>
                      <li v-if="getEmail"  @click="hideDropdown">
                        <router-link to="/profile"
                          ><font-awesome-icon :icon="faUserAlt"/> <span > 계정</span>
                        </router-link>
                      </li>
                      <li v-if="getEmail"  @click="hideDropdown">
                        <a @click="linkedData(0)" href="#" data-toggle="modal" data-target="#largeModal">
                        <font-awesome-icon :icon="faLink"/> <span > 트래킹 코드</span>
                        </a>

                      </li>
                      <li v-if="getEmail"  @click="hideDropdown">
                        <a @click="linkedData(1)" href="#" data-toggle="modal" data-target="#largeModal">
                        <font-awesome-icon :icon="faInfinity"/> <span > API키</span>
                        </a>
                      </li>
                      <li v-if="getEmail"  @click="hideDropdown">
                        <a href="javascript:void(0)" @click="logoutBtn"
                          ><font-awesome-icon :icon="faPowerOff"/>
                          <span> 로그아웃</span></a
                        >
                      </li>
                    </ul>
                  </li>
                  <!-- <li><a href="javascript:void(0);" class="js-right-sidebar"><i class="icon-equalizer"></i></a></li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <aside id="leftsidebar" class="sidebar">
      <div class="container">
        <div class="row clearfix">
          <div class="col-12">
            <div class="menu">
              <ul class="list">
                <li class="header">
                  MAIN<span
                    style="float: right; color: #747474"
                    @click="hideSideMenu"
                    >X</span
                  >
                </li>

                <li v-if="getEmail">
                  <a href="javascript:void(0);" @click="toUserMenu" class="menu-toggle"
                    ><font-awesome-icon :icon="faPencilAlt"/><span>사용자</span></a
                  >

                  <!-- <ul class="ml-menu">
                                    <li><a href="/user/dashboard">전체보기</a></li>
                                   
                                </ul> -->
                </li>
                <li v-if="getEmail">
                  <a href="javascript:void(0);" @click="toDevMenu" class="menu-toggle"
                    ><font-awesome-icon :icon="faPencilAlt"/><span>개발자</span></a
                  >
                  <!-- <ul class="ml-menu">
                                    <li><a href="/developer/main">메인</a></li>
                                   
                                </ul> -->
                </li>
                <li v-if="getEmail">
                  <a href="javascript:void(0);" @click="toLeadMenu" class="menu-toggle"
                  ><font-awesome-icon :icon="faPencilAlt"/><span>리드</span></a
                  >
                </li>

                <!-- <li   v-if="getEmail"><a href="javascript:void(0);" class="menu-toggle"><span></span></a> -->
                <!-- <ul class="ml-menu">
                                    <li><a href="map-yandex.html">YandexMap</a></li>
                                    <li><a href="map-jvectormap.html">jVectorMap</a></li>
                                </ul> -->
                <!-- </li>                 -->
              </ul>
            </div>
          </div>
        </div>
      </div>




    </aside>
    <track-api-code />




<!--    <div class="modal fade" id="largeModal" tabindex="-1" role="dialog">-->
<!--      <div class="modal-dialog modal-lg" role="document">-->
<!--        <div class="modal-content">-->
<!--          <div class="modal-header">-->
<!--            <h4 class="title" id="largeModalLabel">Modal title</h4>-->
<!--          </div>-->
<!--          <div class="modal-body"> dignissim nibh faucibus ullamcorper.-->
<!--            Fusce pulvinar libero vel ligula iaculis ullamcorper. Integer dapibus, mi ac tempor varius, purus-->
<!--            nibh mattis erat, vitae porta nunc nisi non tellus. Vivamus mollis ante non massa egestas fringilla.-->
<!--            Vestibulum egestas consectetur nunc at ultricies. Morbi quis consectetur nunc. </div>-->
<!--          <div class="modal-footer">-->
<!--            <button type="button" class="btn btn-default waves-effect">SAVE CHANGES</button>-->
<!--            <button type="button" class="btn btn-danger btn-simple waves-effect" data-dismiss="modal">CLOSE</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->








  </div>
</template>

<script scope>
import eventbus from "@/store/modules/devEventBus";
import trackApiCode from "@/components/user/modal/trackApiCode";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import {faUserAlt} from "@fortawesome/free-solid-svg-icons";
import {faPowerOff} from "@fortawesome/free-solid-svg-icons";
import {faLink} from "@fortawesome/free-solid-svg-icons";
import {faInfinity} from "@fortawesome/free-solid-svg-icons";

export default {
  components : {
    FontAwesomeIcon,
    trackApiCode
  },
  data() {
    return {
      clickedUserDropDown: false,
      emailOfUser: "",

      faPencilAlt,
      faUserAlt,
      faPowerOff,
      faLink,
      faInfinity
    };
  },
  methods: {
    toLeadMenu(){
      this.$router.push({name:'LeadListPage'})
    },
    toUserMenu(){
      this.$router.push({name:'WorkflowPage'})
    },
    toDevMenu(){
      this.$router.push({name:'DevelopPage'})
    },
    linkedData(val){
      console.log("여기")
      this.$store.state.userStore.trackAppModal = !this.$store.state.userStore.trackAppModal

      if(val == 0){
        this.$store.state.userStore.trackOrApi = 0
      } else {
        this.$store.state.userStore.trackOrApi = 1
      }



    },
    dropdownLogin() {
      this.clickedUserDropDown = !this.clickedUserDropDown;
      // console.log("onTest..");
    },
    logoutBtn() {
      if (confirm("로그아웃 하시겠습니까?")) {

        this.$store.state.userStore.loginSuccess = false;
        this.$store.state.userStore.loginError = false;
        this.$store.state.userStore.userEmail = null;
        this.$store.state.userStore.userName = null;
        this.$store.state.userStore.userCode = null;
        this.$store.state.userStore.trackingCode = null;
        this.$store.state.userStore.apiKey = null;
        this.$store.state.userStore.trackAppModal = false;

        location.href = "/";







        // this.$store.dispatch("logout");
      } else {
        alert("취소 되었습니다.");
      }
    },
    showLeftMenu() {
      document.getElementsByClassName("overlay")[0].style.display = "block";
      eventbus.$emit("showLeftMenu", "show");
    },
    hideSideMenu() {
      document.getElementsByClassName("overlay")[0].style.display = "none";
      eventbus.$emit("showLeftMenu", "hide");
    },
    hideDropdown(){
      this.clickedUserDropDown = !this.clickedUserDropDown

    }
  },
  computed: {
    getEmail() {
      console.log(
        "for login in in ...",
        this.$store.state.userStore.loginSuccess,
        this.$store.state.userStore.userEmail
      );
      var check = this.$store.state.userStore.loginSuccess;

      if (check) {
        console.log("gpdj...", this.$store.state.userStore.userEmail);
      }
      return check;
    },
    loginoutText() {
      if (this.$store.state.userStore.userEmail != null) {
        return this.$store.state.userStore.userName;
      } else {
        return " 로그인";
      }
    },
  },
  created() {},
};
</script>
